export default {
	seo_meta_title_leaguepass: 'NBA | NBA Videos und Highlights',
	seo_meta_desc_leaguepass: 'NBA Video mit Videos und Highlights aus der NBA',
	seo_meta_keywords_leaguepass: 'NBA Videos, NBA Highlights, Basketball Videos, top-plays, dunks, berichte',
	seo_meta_title_featured: 'NBA | Vorgestellt',
	seo_meta_desc_featured: '',
	seo_meta_keywords_featured: '',
	seo_meta_title_nbatv: 'NBA | NBA TV Live',
	seo_meta_desc_nbatv: 'NBA TV Live ist der Rund-um-die-Uhr-Livestream von NBA TV – jede Woche NBA-Spiele live oder aus dem Archiv, Sendungen aus dem Studio und Spielanalysen.',
	seo_meta_keywords_nbatv: 'NBA TV Channel, the beat, hardwood classics, nba live, real nba, nba gametime, fantasy insider, studio shows, Sprungball',
	seo_meta_title_classicgames: 'NBA | Spiele-Klassiker',
	seo_meta_desc_classicgames: '',
	seo_meta_keywords_classicgames: '',
	seo_meta_title_videolist: 'NBA | Videoliste',
	seo_meta_desc_videolist: '',
	seo_meta_keywords_videolist: '',
	seo_meta_title_shows: 'Exklusive NBA-TV-Shows',
	seo_meta_desc_shows: '',
	seo_meta_keywords_shows: '',
	seo_meta_title_home: 'NBA-Startseite',
	seo_meta_desc_home: '',
	seo_meta_keywords_home: '',
	seo_meta_title_channels: 'NBA | Kanäle',
	seo_meta_desc_channels: '',
	seo_meta_keywords_channels: '',
	seo_meta_pre_title_channel: 'NBA | Kanal',
	seo_meta_pre_title_categories: 'NBA | Kategorien',
	seo_meta_title_categories: 'NBA | {0}',
	seo_meta_desc_categories: '',
	seo_meta_keywords_categories: '',
	seo_meta_pre_title_category: 'NBA | Kategorie',
	seo_meta_title_category: 'NBA | {0}',
	seo_meta_desc_category: '',
	seo_meta_keywords_category: '',
	seo_meta_pre_title_video: 'NBA | Video',
	seo_meta_pre_title_event: 'NBA | Event',
	seo_meta_title_events: 'NBA | Events',
	seo_meta_desc_events: '',
	seo_meta_keywords_events: '',
	seo_meta_title_event: 'NBA | Events: {0}',
	seo_meta_desc_event: '',
	seo_meta_keywords_event: '',
	seo_meta_title_search: 'NBA | Suche',
	seo_meta_desc_search: '',
	seo_meta_keywords_search: '',
	seo_meta_title_notfound: 'NBA | Seite nicht gefunden',
	seo_meta_desc_notfound: '',
	seo_meta_keywords_notfound: '',
	seo_meta_pre_title_game: 'NBA-Spiel:',
	seo_meta_title_game: 'NBA | {0}',
	seo_meta_desc_game: '',
	seo_meta_keywords_game: '',
	seo_meta_title_video: 'NBA | NBA Videos und Highlights',
	seo_meta_desc_video: 'NBA Video mit Videos und Highlights aus der NBA',
	seo_meta_keywords_video: 'NBA Videos, NBA Highlights, Basketball Videos, top-plays, dunks, berichte',
	seo_meta_title_channel: 'NBA | NBA TV Live',
	seo_meta_desc_channel: 'NBA TV Live ist der Rund-um-die-Uhr-Livestream von NBA TV – jede Woche NBA-Spiele live oder aus dem Archiv, Sendungen aus dem Studio und Spielanalysen.',
	seo_meta_keywords_channel: 'NBA TV Channel, the beat, hardwood classics, nba live, real nba, nba gametime, fantasy insider, studio shows, Sprungball',
	seo_meta_title_tvguide: 'NBA | NBA TV Programm',
	seo_meta_desc_tvguide: 'NBA TV Live ist der Rund-um-die-Uhr-Livestream von NBA TV – jede Woche NBA-Spiele live oder aus dem Archiv, Sendungen aus dem Studio und Spielanalysen.',
	seo_meta_keywords_tvguide: 'NBA TV Channel, the beat, hardwood classics, nba live, real nba, nba gametime, fantasy insider, studio shows, Sprungball',
	timezone: 'ET',
	default_feed_error_message: 'Es ist ein Fehler aufgetreten, der Inhalt ist jetzt nicht verfügbar. Möglicherweise kannst du es erneut versuchen.',
	watch_in_app: 'IN DER NBA-APP SCHAUEN',
	no_content: 'Kein Inhalt',
	see_more: 'Mehr anzeigen',
	now_playing: 'AKTUELLE WIEDERGABE',
	nba_tv_lock: 'NBA TV',
	league_pass_lock: 'League Pass',
	league_pass_premium_lock: 'LP PREMIUM',
	error_max_limit_favorite: 'Du hast die maximale Anzahl an Lieblingsvideos erreicht. Entferne einige Lieblingsvideos, bevor du weitere hinzufügst.',
	item_live: 'Live:',
	add_favourite_title: 'ZU DEN FAVORITEN HINZUFÜGEN',
	remove_favourite_title: 'AUS FAVORITEN ENTFERNEN',
	p_channel_live: 'Live:',
	p_channel_schedule_title: 'NBA-TV-Programm',
	p_channel_schedule_watch: 'Ansehen',
	p_channel_schedule_no_date: 'Derzeit kein verfügbarer Termin.',
	p_channel_live24x7_title: 'NBA TV 24/7',
	p_channel_live24x7_see_full_schedule: 'Alle Termine anzeigen',
	p_channel_live24x7_up_next: 'Als Nächstes',
	p_channel_live24x7_on_demand: 'NBA TV: On-Demand',
	p_channel_live24x7_collection: 'Kollektion',
	p_channel_live24x7_demand_1_logo_text: 'Originalsendungen',
	p_channel_live24x7_demand_1_show_name: 'NBA-TV-Shows',
	p_channel_live24x7_demand_1_show_desc: 'NBA-TV-Originalsendungen, darunter Shaqtin\' a Fool, Beyond the Paint, Game Time und Basketball Stories',
	p_channel_live24x7_demand_2_logo_text: 'Klassische Spiele',
	p_channel_live24x7_demand_2_show_name: 'NBA | Spiele-Klassiker',
	p_channel_live24x7_demand_2_show_desc: 'Sieh NBA-Klassiker in voller Länge, einschließlich aller Finals seit 2000, historischer Ligamomente und legendärer Spieler.',
	p_channel_clips_title: 'NBA-TV-Clips',
	p_channel_category_title: 'NBA TV',
	p_channel_playlist_title: 'Spielplan',
	p_nba_tv_shows: 'Exklusive NBA-TV-Shows',
	p_nba_tv_no_access_title: '24/7 NBA: Bleib auf dem Laufenden mit Spielanalysen, Studioanalysen, Originalsendungen und vielem mehr!',
	p_nba_tv_no_access_desc: 'Sieh Live-Spiele sowie Shows und NBA-Klassiker On-Demand.',
	p_nba_tv_no_access_note: 'Es können Übertragungseinschränkungen gelten.',
	tv_show_item_latest_episode: 'letzte Folge',
	tv_show_item_no_latest_episode: 'keine letzte Folge',
	see_all: 'Alles ansehen',
	header_menu_watch: 'Ansehen',
	header_menu_featured: 'IM BLICKPUNKT',
	header_menu_nba_tv: 'NBA TV',
	header_menu_league_pass: 'League Pass',
	players: 'Spieler',
	videos: 'Videos',
	teams: 'Teams',
	most_searched: 'AM HÄUFIGSTEN GESUCHT',
	no_result: 'Keine Daten',
	search_filter_type_most_relevant: 'Relevanteste',
	search_filter_type_most_viewed: 'Am häufigsten gesehen',
	search_filter_type_most_recent: 'Neueste',
	search_filter_type_last_30_days: 'Letzte 30 Tage',
	search_filter_type_last_6_months: 'Letzte 6 Monate',
	search_result_label: 'Suchergebnisse für \'{keyword}\'',
	search_result_info: 'Alle Ergebnisse für {keyword} anzeigen',
	search_placeholder: 'Videobibliothek durchsuchen',
	load_more: 'Weitere laden…',
	button_subscribe: 'Abonnieren',
	button_sign_in: 'Anmelden',
	p_league_pass_no_access_title: 'Sieh Spiele live oder als Wiederholung auf jedem Gerät, einschließlich Computer, Smartphone und Fernseher!',
	p_league_pass_no_access_desc: 'Sei bei der Action dabei: Sieh die gesamte Liga oder dein Lieblingsteam, wähle ein einzelnes Spiel aus oder weitere Optionen.',
	p_league_pass_no_access_note: 'Es gelten die Geschäftsbedingungen',
	category_title: 'Video',
	p_video_playlist_title: 'Playlist:',
	p_no_access_league_pass_title: 'Schalte den NBA League Pass frei, um Folgendes zu sehen:',
	p_no_access_league_pass_desc: 'Sei bei der Action dabei: Sieh die gesamte Liga oder dein Lieblingsteam, wähle ein einzelnes Spiel aus oder weitere Optionen.',
	p_no_access_league_pass_terms: 'Es gelten die Geschäftsbedingungen',
	p_no_access_league_pass_geo_desc: 'Aufgrund deines aktuellen Standorts kannst du dieses Spiel nicht über NBA League Pass und NBA TV sehen. Diese Spiele werden drei Tage nach der Übertragung für NBA League Pass-Abonnenten verfügbar sein. Bitte sieh in deinem lokalen Fernseh- und Radioprogramm nach, um zu erfahren, wo Übertragungen angeboten werden.',
	p_no_access_league_pass_not_found_desc: 'Das angeforderte Video wurde leider nicht gefunden.',
	p_no_access_event_not_found_desc: 'Das angeforderte Event wurde leider nicht gefunden.',
	p_no_access_nba_tv_title: 'Schalte NBA TV frei, um Folgendes anzusehen:',
	p_no_access_nba_tv_desc: 'Sieh Live-Spiele sowie Shows und NBA-Klassiker On-Demand.',
	p_no_access_nba_tv_terms: 'Es gelten die Geschäftsbedingungen',
	p_no_access_nba_tv_geo_desc: 'Aufgrund deines aktuellen Standorts kannst du dieses Spiel nicht über NBA League Pass und NBA TV sehen. Diese Spiele werden drei Tage nach der Übertragung für NBA League Pass-Abonnenten verfügbar sein. Bitte sieh in deinem lokalen Fernseh- und Radioprogramm nach, um zu erfahren, wo Übertragungen angeboten werden.',
	p_no_access_nba_tv_not_found_desc: 'Der angeforderte Kanal wurde leider nicht gefunden.',
	p_no_access_up_next: 'Als Nächstes:',
	p_video_completed_title: 'Playlist abgeschlossen',
	p_video_completed_desc: 'Gehe zurück, um nach Inhalten zu suchen oder die nächste Playlist abzuspielen.',
	p_video_share_to: 'Teilen auf:',
	p_video_more_to_watch: 'Es gibt noch mehr zu sehen:',
	p_event_section_title: 'EVENT',
	p_event_playlist_title: 'Playlist:',
	p_event_button_watch: 'Ansehen',
	p_event_button_listen: 'Anhören',
	p_event_button_ticket: 'Ticket',
	notfound: 'Die angeforderte Seite wurde leider nicht gefunden.',
	notfound_desc: 'Überprüfe die URL auf Fehler.<br/>Du kannst auch versuchen, deinen Inhalt über die Seitennavigation oder das Suchtool zu finden.',
	modal_pcm_header_title: '',
	modal_pcm_body_title: '',
	modal_pcm_body_description: 'Dein NBA League Pass Konto hat die maximale Anzahl Streams erreicht. Klicke auf „Fortsetzen“, um auf diesem Gerät weiterzuschauen.',
	modal_pcm_custom: 'Fortsetzen',
	modal_pcm_close: 'Abbrechen',
	modal_adobe_concurrency_header_title: 'Videoverbindung unterbrochen',
	modal_adobe_concurrency_body_title: '',
	modal_adobe_concurrency_body_description: 'Dein Stream wurde geschlossen. Das kann daran liegen, dass du die maximale Anzahl an Streams wiedergegeben hast, das Netzwerk unterbrochen wurde oder ein technischer Fehler aufgetreten ist. Bitte melde dich erneut an und wähle einen Kanal aus, um fortzufahren.',
	modal_adobe_concurrency_close: 'Fertig',
	modal_video_unsupported_header_title: '',
	modal_video_unsupported_body_title: '',
	modal_video_unsupported_body_description: 'Dieses Video kann nicht auf deinem Gerät wiedergegeben werden. Klicke<a href=\'https://neulion-a.akamaihd.net/nlweb/h5support/player.html\' target=\'_blank\'> HIER</a> für weitere Hilfe.',
	modal_video_unsupported_custom: '',
	modal_video_unsupported_close: 'OK',
	freesample_notice_time: 'Verbleibende Zeit',
	freesample_notice_title: 'Genieße deine {0} Minuten Zugang',
	freesample_notice_desc: 'Abonniere ein komplettes League Pass-Paket, um nach Ablauf der {0} Minuten weiter auf Inhalte zuzugreifen.',
	freesample_notice_subscribe_button: 'Abonnieren',
	freesample_notice_cancel_button: 'JEDERZEIT KÜNDBAR',
	freesample_popup_title: 'DEIN ZUGANG IST ABGELAUFEN',
	freesample_popup_subtitle: 'Abonniere League Pass, um noch mehr tolle NBA-Inhalte anzusehen.',
	freesample_popup_link: 'MEHR ERFAHREN!',
	freesample_popup_get_minutes_button: '{0}  MINUTEN HOLEN',
	reg_required_desc: 'Du musst dich anmelden, um diesen Inhalt anzusehen',
	favorite_teams_title: 'Lieblingsteams',
	bookmarked_title: 'Gespeichert',
	watch_history_title: 'Weiter schauen',
	game_schedule_title: 'Spielplan',
	recommended_title: 'Empfohlen',
	season_text: 'Saison',
	section_tv_provider_title: 'Mein TV-Anbieter',
	section_tv_provider_desc: 'Erhalte Zugriff auf Live-Spiele und Streams von deinem TV-Anbieter.',
	section_tv_provider_faq: 'FAQs zu TV-Anbietern',
	section_tv_provider_sign_out: 'Abmelden',
	header_menu_account_my_account: 'Mein Konto',
	header_menu_account_manage_account: 'Konto verwalten',
	header_menu_account_favorite_teams: 'Lieblingsteams',
	header_menu_account_favorite_players: 'Lieblingsspieler',
	header_menu_account_viewing_history: 'Bisher angesehen',
};
